<template >
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="1000">
      <template v-slot:activator="{on, attrs}">
        <v-btn
          color=#344955
          dark
          v-bind="attrs"
          v-on="on"
          >
          Instructions for Search Engine
        </v-btn>
      </template>
      <v-card color="#4A6572" >
        <v-card-subtitle class="headline white--text"  >
          <p><span style="margin-left:2em">To use, select a category of passenger from the drop down menu.
            You may click “Press to Search” to obtain all individuals in that category, or
            search by name. On the left, there are additional filters to aid you in your search.
          </span>

            <br><span style="margin-left:2em">Once an individual is located, click on the name for more
                      information on that person, including source material that mentions that person as being on
                      the Sultana, and a photo of the individual and/or headstone if available.</span></p>
        </v-card-subtitle>

      </v-card>
    </v-dialog>
  </div>
</template>

<!--TODO: Property or method "dialog" is not defined on the instance but referenced during render. -->
<!--Make sure that this property is reactive, either in the data option, or for class-based components, -->
<!--by initializing the property.-->

<script>
export default {
name: "SearchPopup"

}
</script>



